<template>
  <div class="b-unit" @dblclick="activate">
    <v-row v-if="!noHeader" no-gutters class="b-unit__header">
      <h2 v-if="title">{{ title }}</h2>
      <v-spacer />
      <slot name="header-append" v-bind="{ readOnly }" />
    </v-row>
    <div
      :class="{
        'b-unit__content': !table,
        'b-unit__content--table': table,
        'b-unit__content--no-header': noHeader,
        'pb-0': withPflichtfeldHint
      }"
    >
      <slot v-bind="{ readOnly }" />
    </div>
    <div class="b-unit__content pflichtfeld-hint" v-if="withPflichtfeldHint">
      <v-row class="pa-0">
        <v-col>
          <p class="mb-0">* Diese Felder sind verpflichtend.</p>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import dataMixin from '@/mixins/data-mixin';
export default {
  props: {
    uuid: String,
    title: String,
    table: Boolean,
    noHeader: Boolean,
    withPflichtfeldHint: { type: Boolean, default: false }
  },
  computed: {
    readOnly() {
      return this.uuid && this._readOnly && !this.active;
    }
  },
  mixins: [
    dataMixin('_readOnly', 'transientData.readOnly'),
    dataMixin('active', self => `transientData.readOnly$${self.uuid || 'noId'}`)
  ],
  methods: {
    activate() {
      this.active = true;
    }
  },
  watch: {
    _readOnly(val) {
      if (val) this.active = false;
    }
  }
};
</script>

<style lang="scss">
.b-unit {
  border: solid;
  border-radius: 8px;
  border-width: 1px;
  // border-color: var(--v-border0-base);
  border-color: #8A8A8A;
  overflow: hidden;
  height: 100%;
  background: #fff;
  &__content {
    padding: 0px 32px 32px;

    &--table {
      padding-bottom: 0px;
    }

    &--no-header {
      padding-top: 16px;
    }
  }

  .pflichtfeld-hint {
    padding-top: 16px;
  }

  &__header {
    padding: 32px 32px 16px;
  }
}
</style>
